// React Basic and Bootstrap
import React, { Component } from "react"

class Gallery extends Component {
  render() {
    return null
  }
}

export default Gallery
